import { RootState } from "../../types/State.interface";

export const selectSpheres = (state: RootState) => state.gorod.spheres;
